import * as React from "react";
import { SVGProps, memo } from "react";

const SvgErrorFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81 2.813c-.447 0-.876.177-1.193.494l-3.31 3.31a1.687 1.687 0 0 0-.494 1.194v8.378c0 .448.177.877.494 1.194l3.31 3.31c.317.317.746.494 1.194.494h8.378c.448 0 .877-.177 1.194-.494l3.31-3.31c.317-.317.494-.746.494-1.194V7.811c0-.448-.177-.877-.494-1.194l-3.31-3.31a1.688 1.688 0 0 0-1.194-.494H7.811ZM12 6.374c.518 0 .938.42.938.938v5.625a.937.937 0 1 1-1.876 0V7.311c0-.517.42-.937.938-.937Zm1.125 9.938a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z"
      fill="#E33B24"
    />
  </svg>
);

const Memo = memo(SvgErrorFill);

export default Memo;
